import { useMutation } from '@tanstack/react-query';

import { searchTreatmentCount } from '@/services/main/treatmentReport';
import { useClinicContext } from './useClinicContext';
import { useClinicPortalServiceType } from './clinicPortalServiceType';

interface SearchTreatmentCountPayload {
  patientId: string;
  treatmentReportDate: string;
  secondFlag?: boolean;
  treatmentYearmonth?: number | string | null;
}

export const useSearchTreatmentCount = () => {
  const { tenant, clinicNumber } = useClinicContext();
  const serviceType = useClinicPortalServiceType();

  return useMutation({
    mutationFn: ({ patientId, treatmentReportDate, secondFlag = false, treatmentYearmonth }: SearchTreatmentCountPayload) =>
      searchTreatmentCount(
        tenant! || '',
        clinicNumber! || '',
        patientId,
        serviceType,
        treatmentReportDate,
        secondFlag,
        treatmentYearmonth
      ),
  });
};
